import { StripeConfirmModalForm } from "./StripeConfirmModalForm";

const StripeConfirmModalFormWrapper = ({
  selectedListingId,
  setSelectedListingId,
  openStripeConfirmModal,
  setOpenStripeConfirmModal,
  listing,
  getListing,
}) => {
  const itemIdForUpdate = null;
  const isLoading = false;

  if (selectedListingId) {
    return (
      <StripeConfirmModalForm
        isUserLoading={isLoading}
        user={{ id: undefined }}
        setSelectedListingId={setSelectedListingId}
        selectedListingId={selectedListingId}
        listing={listing}
        getListing={getListing}
        openStripeConfirmModal={openStripeConfirmModal}
        setOpenStripeConfirmModal={setOpenStripeConfirmModal}
      />
    );
  }
  return null;
};

export { StripeConfirmModalFormWrapper };
